import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOptionalBillingRealtime } from '../../contexts/BillingRealtimeContext';
const BILLING_MODULE_PATHS = ['/cobrancas', '/notas-fiscais'];
function isBillingModulePath(pathname) {
    return BILLING_MODULE_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));
}
export function BillingRealtimeModuleRetention() {
    const { pathname } = useLocation();
    const realtime = useOptionalBillingRealtime();
    const retain = realtime?.retain;
    const isInBillingModule = isBillingModulePath(pathname);
    useEffect(() => {
        if (!isInBillingModule || !retain)
            return;
        return retain();
    }, [isInBillingModule, retain]);
    return null;
}
